import angular from 'angular';
import SignalRService from '@/shared/services/SignalRService';

angular
  .module('commonServices')
  .factory('jobSvc', [
    '$http',
    '$rootScope',
    'appUrls',
    'authService',
    '$interval',
    '$timeout',
    jobSvc,
  ]);

function jobSvc($http, $rootScope, appUrls, authService, $interval, $timeout) {
  var runningJobs = [];

  function isJobRunning() {
    return runningJobs && runningJobs.length > 0;
  }

  function reloadRunningJobs() {
    $http.get(appUrls.jobs + '/Api/jobs/jobsinprogress').then(function(response) {
      if (response.data) {
        runningJobs = [...response.data];
      }
    });
  }
  reloadRunningJobs();

  var updateJobStatus = function(job) {
    $timeout(function() {
      if (job.status === 0 || job.status === 1) {
        // Add it to the running jobs
        var exists = runningJobs.some(x => x == job.id);
        if (!exists) {
          runningJobs.push(job.id);
        }
      } else {
        var existingJob = runningJobs.find(x => x == job.id);
        if (existingJob) {
          var idx = runningJobs.indexOf(existingJob);
          if (idx >= 0) runningJobs.splice(idx, 1);
        }
      }
    }, 100);
  };

  SignalRService.subscribe('jobUpdated', updateJobStatus);

  return {
    isJobRunning: isJobRunning,
  };
}
